import React, { useState, useEffect, useRef, useCallback } from "react";
import "../../App.css";
import { useApp } from '../../core/context';
import { INR, initials, today, uuid, invoiceStatus, dateInRange, logAudit, notify } from '../../core/helpers';
import { sb } from '../../core/db';
import { TASK_STATUSES, TASK_REQUIREMENT_TYPES, DEFAULT_DOC_TEMPLATES } from '../../core/constants';
import { Badge } from '../../components/Badge';
import { FilterBar } from '../../components/FilterBar';
import { IconProperties } from '../../icons.properties';
import { Icon } from '../../components/Icon';
import { createAuthFor, syncAuthPassword } from '../../api';
import { generateTempPassword } from '../../core/helpers';


function ResetPasswordModal({ data, onClose }) {
  const { showToast } = useApp();
  const [newPwd, setNewPwd] = useState(generateTempPassword());
  const save = async () => {
    if (!newPwd || newPwd.length < 6) { showToast("Password must be at least 6 characters", "error"); return; }
    const res = await syncAuthPassword(data.userId, newPwd, { requireChangeOnNextLogin: true });
    if (!res.ok) { showToast("Failed to reset password: " + (res.error || "please try again"), "error"); return; }
    showToast(`Password for ${data.name || data.email || "user"} reset to: ${newPwd}`, "success");
    onClose();
  };
  return (
    <div className="modal-box" style={{ maxWidth: 420 }}>
      <div className="modal-head">
        <div className="modal-title">Reset Password{data.name ? ` — ${data.name}` : ""}</div>
        <button className="modal-close" onClick={onClose}><Icon name="close" size={16} /></button>
      </div>
      <div className="modal-body">
        <div className="f-group">
          <label className="f-label">New Password</label>
          <input className="f-input" value={newPwd} onChange={e => setNewPwd(e.target.value)} placeholder="Min 6 characters" />
          <div className="f-hint">Share this password with the user. They can change it after login via Change Password.</div>
        </div>
      </div>
      <div className="modal-foot">
        <button className="btn" onClick={onClose}>Cancel</button>
        <button className="btn btn-primary" onClick={save}>Reset Password</button>
      </div>
    </div>
  );
}


export { ResetPasswordModal };
